export default {
  openFileDialog: 'open-file-dialog',
};
